import { render } from "./free-gift.vue?vue&type=template&id=01c13750"
import script from "./free-gift.vue?vue&type=script&lang=js"
export * from "./free-gift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__